"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStopwatch = void 0;
const react_1 = require("react");
const useStopwatch = () => {
    const [interval, setStateInterval] = (0, react_1.useState)(undefined);
    const [time, setTime] = (0, react_1.useState)(0);
    const start = (0, react_1.useCallback)(() => {
        setStateInterval((state) => {
            if (!state) {
                return setInterval(() => {
                    setTime((prev) => prev + 1);
                }, 10);
            }
        });
    }, []);
    const pause = (0, react_1.useCallback)(() => {
        clearInterval(interval);
        setStateInterval(undefined);
    }, [interval]);
    const stop = (0, react_1.useCallback)(() => {
        pause();
        setTime(0);
    }, [pause]);
    const restart = (0, react_1.useCallback)(() => {
        stop();
        start();
    }, [start, stop]);
    return { time, pause, start, restart, stop };
};
exports.useStopwatch = useStopwatch;
//# sourceMappingURL=useStopwatch.js.map